import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { IntakePatientProfileTab } from "components/intake-queue/models/intake-patient-profile-type";
import { ToastController } from "ionic-angular";

@Component({
  selector: "vertical-tabs",
  templateUrl: "vertical-tabs.html",
  // role=tablist on the host so the role=tab children are valid for every
  // consumer (location-group, billing-settings, workforce, qa-controls,
  // intake-patient-profile) without wrapping the projected divs in a new
  // element, which would disturb their layout.
  host: { role: "tablist" },
})
export class VerticalTabs implements OnInit {
  @Input() tabs: string[] = [];
  @Input() tab: string = "";
  @Input() status: { [key: string]: string } = {};
  @Input() enableValidation: boolean = false;
  @Output() changeActiveTab = new EventEmitter<string>();
  activeTab: string = "";

  constructor(private toastCtrl: ToastController) {}

  ngOnInit(): void {
    if (this.tab !== "") {
      this.activeTab = this.tab;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tab) {
      this.activeTab = this.tab;
    }
  }

  setActiveTab(tab: string) {
    if (
      this.enableValidation &&
      !this.isTabClickable(IntakePatientProfileTab.PATIENT_DETAILS)
    ) {
      this.presentToast("Please save Patient Details to proceed");
      return;
    }
    this.activeTab = tab;
    this.changeActiveTab.emit(tab);
  }

  isTabClickable(tab: string): boolean {
    return this.status[tab] === "complete";
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });
    toast.present();
  }

  getStatus(tab: string): string {
    return this.status[tab] || "default";
  }
}



// WEBPACK FOOTER //
// ./src/components/system-admin/vertical-tabs/vertical-tabs.ts